import { DefaultTheme, isMobile } from "common/components/ui";
import styled from "@emotion/styled";
import React, { FC } from "react";

const Outer = styled.div<{}, DefaultTheme>`
  margin: 30px 15px;
  margin-bottom: 0;
  position: relative;
  ${({ theme }) =>
    isMobile(theme) &&
    `
    margin: 30px ${theme.spacing.S2};
  `}
`;

const Inner = styled.div<Pick<ContainerProps, "fullWidth">, DefaultTheme>`
  margin: 0 auto;
  padding: 0 15px;
  max-width: ${({ fullWidth }) => (fullWidth ? "100%" : "1028px")};
  ${({ theme }) =>
    isMobile(theme) &&
    `
    padding: 0;
  `}
`;

export interface ContainerProps {
  /**
   * @deprecated
   * When a react-select component near the bottom of the page is opened, this creates an additional,
   * unwanted scrollbar on the page. Setting a min height is provided as a temporary workaround.
   * */
  minHeight?: string;
  className?: string;
  fullWidth?: boolean;
}

/**
 * Horizontally centered container with standard padding and maximum width.
 */
export const Container: FC<ContainerProps> = ({ minHeight, fullWidth, children, className }) => (
  <Outer style={{ minHeight }} id="outerContainer" className={className}>
    <Inner fullWidth={fullWidth}>{children}</Inner>
  </Outer>
);
